export const SYNC_SUFFIX = "Sync";
export const CONTEXT_REGEX = /^\[.+\]/i;
